export const STICKER_COLORS = [
    "#FFFBB4",
    "#FFC5A0",
    "#FED1F1",
    "#FFC0BF",
    "#FFB8EF",
    "#CBC1FF",
    "#BFF7CA",
    "#BBF0F2",
    "#AAE9FF",
    "#9FC5FF",
    "#DADDE4",
    "#2C2D32",
] as const;
export const STICKER_TEXT_FIT_THRESHOLD_PX = 4;
